export default __webpack_public_path__ + "716c4bc4d557591de1fd87a0b31288c9.png";